function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Utility for generating row / column headers
 */
import { isArray } from 'vega-util';
import { FACET_CHANNELS } from '../../channel';
import { vgField } from '../../channeldef';
import { HEADER_LABEL_PROPERTIES, HEADER_LABEL_PROPERTIES_MAP, HEADER_TITLE_PROPERTIES, HEADER_TITLE_PROPERTIES_MAP } from '../../header';
import { isSortField } from '../../sort';
import { isFacetMapping } from '../../spec/facet';
import { contains, isEmpty, normalizeAngle, replaceAll } from '../../util';
import { defaultLabelAlign, defaultLabelBaseline } from '../axis/properties';
import { sortArrayIndexField } from '../data/calculate';
import { formatSignalRef } from '../format';
import { isFacetModel } from '../model';
import { getHeaderChannel, getHeaderProperties, getHeaderProperty } from './common';
import { HEADER_TYPES } from './component';
// TODO: rename to assembleHeaderTitleGroup
export function assembleTitleGroup(model, channel) {
  var title = model.component.layoutHeaders[channel].title;
  var config = model.config ? model.config : undefined;
  var facetFieldDef = model.component.layoutHeaders[channel].facetFieldDef ? model.component.layoutHeaders[channel].facetFieldDef : undefined;
  var _getHeaderProperties = getHeaderProperties(['titleAnchor', 'titleAngle', 'titleOrient'], facetFieldDef.header, config, channel),
    titleAnchor = _getHeaderProperties.titleAnchor,
    ta = _getHeaderProperties.titleAngle,
    titleOrient = _getHeaderProperties.titleOrient;
  var headerChannel = getHeaderChannel(channel, titleOrient);
  var titleAngle = normalizeAngle(ta);
  return {
    name: "".concat(channel, "-title"),
    type: 'group',
    role: "".concat(headerChannel, "-title"),
    title: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      text: title
    }, channel === 'row' ? {
      orient: 'left'
    } : {}), {}, {
      style: 'guide-title'
    }, defaultHeaderGuideBaseline(titleAngle, headerChannel)), defaultHeaderGuideAlign(headerChannel, titleAngle, titleAnchor)), assembleHeaderProperties(config, facetFieldDef, channel, HEADER_TITLE_PROPERTIES, HEADER_TITLE_PROPERTIES_MAP))
  };
}
export function defaultHeaderGuideAlign(headerChannel, angle) {
  var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'middle';
  switch (anchor) {
    case 'start':
      return {
        align: 'left'
      };
    case 'end':
      return {
        align: 'right'
      };
  }
  var align = defaultLabelAlign(angle, headerChannel === 'row' ? 'left' : 'top', headerChannel === 'row' ? 'y' : 'x');
  return align ? {
    align: align
  } : {};
}
export function defaultHeaderGuideBaseline(angle, channel) {
  var baseline = defaultLabelBaseline(angle, channel === 'row' ? 'left' : 'top', channel === 'row' ? 'y' : 'x', true);
  return baseline ? {
    baseline: baseline
  } : {};
}
export function assembleHeaderGroups(model, channel) {
  var layoutHeader = model.component.layoutHeaders[channel];
  var groups = [];
  var _iterator = _createForOfIteratorHelper(HEADER_TYPES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var headerType = _step.value;
      if (layoutHeader[headerType]) {
        var _iterator2 = _createForOfIteratorHelper(layoutHeader[headerType]),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var headerComponent = _step2.value;
            var group = assembleHeaderGroup(model, channel, headerType, layoutHeader, headerComponent);
            if (group != null) {
              groups.push(group);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return groups;
}
function getSort(facetFieldDef, channel) {
  var sort = facetFieldDef.sort;
  if (isSortField(sort)) {
    var _sort$order;
    return {
      field: vgField(sort, {
        expr: 'datum'
      }),
      order: (_sort$order = sort.order) !== null && _sort$order !== void 0 ? _sort$order : 'ascending'
    };
  } else if (isArray(sort)) {
    return {
      field: sortArrayIndexField(facetFieldDef, channel, {
        expr: 'datum'
      }),
      order: 'ascending'
    };
  } else {
    return {
      field: vgField(facetFieldDef, {
        expr: 'datum'
      }),
      order: sort !== null && sort !== void 0 ? sort : 'ascending'
    };
  }
}
export function assembleLabelTitle(facetFieldDef, channel, config) {
  var _getHeaderProperties2 = getHeaderProperties(['format', 'formatType', 'labelAngle', 'labelAnchor', 'labelOrient', 'labelExpr'], facetFieldDef.header, config, channel),
    format = _getHeaderProperties2.format,
    formatType = _getHeaderProperties2.formatType,
    labelAngle = _getHeaderProperties2.labelAngle,
    labelAnchor = _getHeaderProperties2.labelAnchor,
    labelOrient = _getHeaderProperties2.labelOrient,
    labelExpr = _getHeaderProperties2.labelExpr;
  var titleTextExpr = formatSignalRef({
    fieldOrDatumDef: facetFieldDef,
    format: format,
    formatType: formatType,
    expr: 'parent',
    config: config
  }).signal;
  var headerChannel = getHeaderChannel(channel, labelOrient);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    text: {
      signal: labelExpr ? replaceAll(replaceAll(labelExpr, 'datum.label', titleTextExpr), 'datum.value', vgField(facetFieldDef, {
        expr: 'parent'
      })) : titleTextExpr
    }
  }, channel === 'row' ? {
    orient: 'left'
  } : {}), {}, {
    style: 'guide-label',
    frame: 'group'
  }, defaultHeaderGuideBaseline(labelAngle, headerChannel)), defaultHeaderGuideAlign(headerChannel, labelAngle, labelAnchor)), assembleHeaderProperties(config, facetFieldDef, channel, HEADER_LABEL_PROPERTIES, HEADER_LABEL_PROPERTIES_MAP));
}
export function assembleHeaderGroup(model, channel, headerType, layoutHeader, headerComponent) {
  if (headerComponent) {
    var title = null;
    var facetFieldDef = layoutHeader.facetFieldDef;
    var config = model.config ? model.config : undefined;
    if (facetFieldDef && headerComponent.labels) {
      var _getHeaderProperties3 = getHeaderProperties(['labelOrient'], facetFieldDef.header, config, channel),
        labelOrient = _getHeaderProperties3.labelOrient;
      // Include label title in the header if orient aligns with the channel
      if (channel === 'row' && !contains(['top', 'bottom'], labelOrient) || channel === 'column' && !contains(['left', 'right'], labelOrient)) {
        title = assembleLabelTitle(facetFieldDef, channel, config);
      }
    }
    var isFacetWithoutRowCol = isFacetModel(model) && !isFacetMapping(model.facet);
    var axes = headerComponent.axes;
    var hasAxes = (axes === null || axes === void 0 ? void 0 : axes.length) > 0;
    if (title || hasAxes) {
      var sizeChannel = channel === 'row' ? 'height' : 'width';
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        name: model.getName("".concat(channel, "_").concat(headerType)),
        type: 'group',
        role: "".concat(channel, "-").concat(headerType)
      }, layoutHeader.facetFieldDef ? {
        from: {
          data: model.getName("".concat(channel, "_domain"))
        },
        sort: getSort(facetFieldDef, channel)
      } : {}), hasAxes && isFacetWithoutRowCol ? {
        from: {
          data: model.getName("facet_domain_".concat(channel))
        }
      } : {}), title ? {
        title: title
      } : {}), headerComponent.sizeSignal ? {
        encode: {
          update: _defineProperty({}, sizeChannel, headerComponent.sizeSignal)
        }
      } : {}), hasAxes ? {
        axes: axes
      } : {});
    }
  }
  return null;
}
var LAYOUT_TITLE_BAND = {
  column: {
    start: 0,
    end: 1
  },
  row: {
    start: 1,
    end: 0
  }
};
export function getLayoutTitleBand(titleAnchor, headerChannel) {
  return LAYOUT_TITLE_BAND[headerChannel][titleAnchor];
}
export function assembleLayoutTitleBand(headerComponentIndex, config) {
  var titleBand = {};
  var _iterator3 = _createForOfIteratorHelper(FACET_CHANNELS),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var channel = _step3.value;
      var headerComponent = headerComponentIndex[channel];
      if (headerComponent !== null && headerComponent !== void 0 && headerComponent.facetFieldDef) {
        var _getHeaderProperties4 = getHeaderProperties(['titleAnchor', 'titleOrient'], headerComponent.facetFieldDef.header, config, channel),
          titleAnchor = _getHeaderProperties4.titleAnchor,
          titleOrient = _getHeaderProperties4.titleOrient;
        var headerChannel = getHeaderChannel(channel, titleOrient);
        var band = getLayoutTitleBand(titleAnchor, headerChannel);
        if (band !== undefined) {
          titleBand[headerChannel] = band;
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return isEmpty(titleBand) ? undefined : titleBand;
}
export function assembleHeaderProperties(config, facetFieldDef, channel, properties, propertiesMap) {
  var props = {};
  var _iterator4 = _createForOfIteratorHelper(properties),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var prop = _step4.value;
      if (!propertiesMap[prop]) {
        continue;
      }
      var value = getHeaderProperty(prop, facetFieldDef === null || facetFieldDef === void 0 ? void 0 : facetFieldDef.header, config, channel);
      if (value !== undefined) {
        props[propertiesMap[prop]] = value;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return props;
}